import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import { searchMenu } from "layout/menuConfig";

// Quick navigation (Ctrl+K / Cmd+K): filters every reachable page, arrows move, Enter opens.
export default function MenuSearch({ open, groups, onClose }) {
  const history = useHistory();
  const [query, setQuery] = useState("");
  const [index, setIndex] = useState(0);
  const results = useMemo(() => searchMenu(groups, query), [groups, query]);

  useEffect(() => {
    if (open) { setQuery(""); setIndex(0); }
  }, [open]);

  useEffect(() => { setIndex(0); }, [query]);

  const go = (entry) => {
    if (!entry) return;
    onClose();
    history.push(entry.path);
  };

  const onKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setIndex((current) => Math.min(current + 1, Math.max(results.length - 1, 0)));
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setIndex((current) => Math.max(current - 1, 0));
    } else if (event.key === "Enter") {
      event.preventDefault();
      go(results[index]);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-label="Ricerca pagine">
      <DialogContent sx={{ p: 1.5 }}>
        <TextField
          autoFocus
          fullWidth
          size="small"
          placeholder="Cerca una pagina…"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={onKeyDown}
          inputProps={{ "aria-label": "Cerca una pagina", role: "combobox", "aria-expanded": true, "aria-controls": "menu-search-results" }}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
        />
        <List dense id="menu-search-results" role="listbox" sx={{ maxHeight: 360, overflowY: "auto", mt: 1 }}>
          {results.map((entry, position) => (
            <ListItemButton
              key={`${entry.groupId}-${entry.path}`}
              role="option"
              aria-selected={position === index}
              selected={position === index}
              onMouseEnter={() => setIndex(position)}
              onClick={() => go(entry)}
            >
              <ListItemText primary={entry.label} secondary={entry.group} />
            </ListItemButton>
          ))}
          {results.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: "center" }}>Nessuna pagina trovata.</Typography>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
}
